export default (number, isInteger = false) => {
    if(number === null || number === undefined) {
        return ""
    }

    return ((isInteger ? (+number).toFixed() : (+number).toFixed(2))).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}